module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/notification-bar/notification-bar.component.scss
// module id = ./src/app/modules/common-module/components/notification-bar/notification-bar.component.scss
// module chunks = 9